module.exports = __webpack_public_path__ + "img/purple-bin.3d7976c6.svg";